<template>
  <a-modal :width="'80%'" v-model="deviceBind" :title="$t('supervise.bindEntity')" :maskClosable="maskClosable">

    <template slot="footer">
      <a-button @click="cancel">
        {{$t('global.cancel')}}
      </a-button>
    </template>

    <a-modal width="50%" v-model="showSecuritySealModal" :title="$t('device.securitySeal')" @ok="doBind" @quit="quit">
      <a-input v-model="securitySeal" :placeholder="$t('device.securitySeal')"></a-input>
    </a-modal>


    <div>
      <div id='components-form-demo-advanced-search'>
        <z-search-form :layout="'small'" :searchOption="searchOption" @search="handleSearch"></z-search-form>
      </div>

      <div class='section-list'>
        <a-alert :showIcon="true" :message="$t('supervise.bindTip')" type="info" />
        <a-spin :spinning="isLoading" :tip="$t('global.loading')">
          <a-table :columns="columns" :dataSource="data" :pagination="pagination" @change="onChange">
            <template slot="date" slot-scope="text">
              <span>{{text ? timeFormat(text) : ''}}</span>
            </template>
            <template slot="bind" slot-scope="text,record">
              <div v-if="!record.entityId">
                <a-popconfirm v-if="data.length" :title="$t('global.confirm')" @confirm="bind(record)">
                  <a href="javascript:;">{{$t('global.bind')}}</a>
                </a-popconfirm>
              </div>
              <div v-else>
                <a-tooltip placement="topLeft" :title="$t('supervise.isBinding')">
                  —
                </a-tooltip>
              </div>
            </template>
          </a-table>
        </a-spin>
      </div>
    </div>

  </a-modal>
</template>

<script>
import config from '@/config'
import ZSearchForm from '@/components/common/SearchForm.vue'
import moment from 'moment'
import {
  mapGetters
} from 'vuex'
import {
  httpModel
} from '../../http/httpModel'
export default {
  name: 'ZDeviceBind',
  data() {
    return {
      isLoading: false,
      deviceBind: false,
      maskClosable: false,
      showSecuritySealModal: false,
      securitySeal: '',
      entity: null,
      pagination: {
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20', '50'],
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: this.showTotal,
        showQuickJumper: true
      },
      orgId: '',
      searchOption: [{
          key: "sn",
          name: "序列号",
          type: "input",
          matchValue: "li",
          placeholder: '序列号',
          value: undefined,
          default: true
        },
        // {
        //     key: "org",
        //     name: "所属机构",
        //     type: "orgChooser",
        //     matchType: "eq",
        //     option:{
        //         showDirect:true,
        //         directFlag:false,
        //         value: ""
        //     }
        // },
        {
          key: "deviceModel",
          name: "设备类型",
          type: "deviceTypeChooser",
          placeholder: '设备类型',
          matchValue: "eq",
          option: {
            allowClear: true,
            value: undefined
          }
        },
        {
          key: "createTime",
          name: "生产日期",
          type: "custom",
          placeholder: '选择日期',
          matchValue: undefined,
          dataType: "time",
          searchTypeData: [{
              key: "大于",
              type: "datePicker",
              paramName: "minTime",
              value: null
            },
            {
              key: "小于",
              type: "datePicker",
              paramName: "maxTime",
              value: null
            },
            {
              key: "之间",
              type: "rangePicker",
              paramName: "minTime,maxTime",
              value: []
            }
          ]
        }
      ],
      data: [],
      searchParams: {},
      timeFormat(timestamp) {
        return moment(timestamp * 1000).format('YYYY-MM-DD')
      },
    }
  },
  components: {
    ZSearchForm
  },
  computed: {
    ...mapGetters(['userId']),
    columns() {
      return [{
        "title": this.$t('columnCheck.manufacturer'),
        "dataIndex": "oui",
        "key": "oui",
        "left": true
      }, {
        "title": this.$t('columnCheck.serialNumber'),
        "dataIndex": "sn",
        "key": "sn",
        "left": true
      }, {
        "title": this.$t('columnCheck.deviceOrg'),
        "key": "orgName",
        "dataIndex": "orgName",
      }, {
        "title": this.$t('columnCheck.deviceModel'),
        "key": "model",
        "dataIndex": "model",
      }, {
        "title": "IMSI",
        "key": "imsi",
        "dataIndex": "imsi",
      }, {
        "title": "ICCID",
        "key": "iccid",
        "dataIndex": "iccid",
      }, {
        "title": this.$t('columnCheck.productionDate'),
        "key": "createTimestamp",
        "dataIndex": "createTimestamp",
        "scopedSlots": {
          "customRender": "date"
        },
        "sorter": true
      }, {
        "title": this.$t('columnCheck.operate'),
        "dataIndex": "operation",
        "key": "operation",
        "scopedSlots": {
          "customRender": "bind"
        },
        "right": true
      }]
    }
  },
  mounted() {
    console.log(this.userId)
  },
  methods: {
    cancel() {
      this.deviceBind = false
    },
    doBind () {
      // console.log(this.securitySeal)
      // console.log(this.currentDeviceId)
      // 用户填写了封签号
      // if (this.securitySeal) {
        this.$http.post(config.api.entity_bind_url + "/" + this.currentDeviceId + '/entity/' + this.entity.id, this.securitySeal).then((response) => {
          if (response.code == 0) {
            this.$notification.success({
              message: this.$t('global.commitSuccess')
            })
            this.$emit('success');
            this.deviceBind = false
            this.currentDeviceId = null
            this.showSecuritySealModal = false
          } else {
            this.$message.error(response.desc)
          }
        })
      // } else {
      //   // 未填写
      //   this.$notification.error({
      //     message: this.$t('global.isRequired')
      //   })
      // }
    },
    quit () {
      this.showSecuritySealModal = false
    },
    bind(device) {
      // console.log(device)
      httpModel.getDeviceModelById(device.id).then((res) => {
        // console.log(res)
        // 必须填入封签号的设备
        if (res.capbilityLockDetect === true && res.capbilityElock === false) {
          // 打开modal
          this.showSecuritySealModal = true
          this.currentDeviceId = device.id
        } else {
          // console.log('50')
          // 不需要封签号，正常操作
          this.$http.post(config.api.entity_bind_url + "/" + device.id + '/entity/' + this.entity.id).then((response) => {
            if (response.code == 0) {
              this.$notification.success({
                message: this.$t('global.commitSuccess')
              })
              this.$emit('success');
              this.deviceBind = false
            } else {
              this.$message.error(response.desc)
            }
          })
        }
      })
    },
    showModel(entity) {
      console.log(entity)
      this.orgId = entity.orgId
      // this.orgId = entity.orgId
      this.entity = entity
      this.deviceBind = true
      this.pageQuery()
    },
    handleSearch(params) {
      this.pagination.current = 1
      this.searchParams = Object.assign({}, params)
      this.pageQuery()
    },
    onChange(page, filters, sorter) {
      this.pagination.pageSize = page.pageSize
      this.pagination.current = page.current
      if (sorter.order) {
        this.searchParams['orderBy'] = sorter.field
        if (sorter.order == "ascend") {
          this.searchParams['sort'] = "ASC"
        } else {
          this.searchParams['sort'] = "DESC"
        }
      } else {
        delete this.searchParams["orderBy"]
        delete this.searchParams["sort"]
      }
      this.pageQuery()
    },
    showTotal(total) {
      return this.$t('global.totalRecords', {
        num: total
      })
    },
    pageQuery() {
      this.isLoading = true
      this.searchParams["pageSize"] = this.pagination.pageSize
      this.searchParams["currentPage"] = this.pagination.current
      // this.searchParams["orgId"] = this.orgId
      console.log(this.searchParams)
      this.$http.post(config.api.device_page_url, this.searchParams).then((response) => {
        if (response.code == 0) {
          response.result.resultList.map(function (item) {
            item.key = item.oui + "_" + item.sn
          })
          this.pagination.total = response.result.page.totalSize
          this.data = response.result.resultList
        }
        this.isLoading = false
      }).catch((err) => {
        console.log(err)
        this.isLoading = false
      })
    }
  }
}
</script>